import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Placeholder from 'react-bootstrap/Placeholder';
import i18next from '../../translations/i18n';
import API from '../../services/API';
import Utils from '../../services/utils';
import heap from '../../containers/App/heap';
import AppTypeContext from '../../contexts/AppTypeContext';

const PlaceholderDiv = () => (
  <>
    <Placeholder as={Card.Title} animation="glow">
      <Placeholder xs={4} size="lg" />
    </Placeholder>
    <Row className="g-5 py-5">
      {[...Array(1).keys()].map((item) => (
        <Col xs={12} sm={6} md={6} lg={4} key={item}>
          <Card className="" key={item}>
            <Card.Body className="p-4 shadow">
              <Placeholder as={Card.Text} animation="glow">
                <Placeholder xs={12} size="lg">
                  &nbsp;
                </Placeholder>
                <Placeholder xs={12} size="lg">
                  &nbsp;
                </Placeholder>
                <Placeholder xs={12} size="lg">
                  &nbsp;
                </Placeholder>
                <Placeholder xs={12} size="lg">
                  &nbsp;
                </Placeholder>
              </Placeholder>
              <Placeholder.Button
                xs={4}
                variant="primary"
                aria-hidden="true"
                className="wt-link-btn"
              >
                &nbsp;
              </Placeholder.Button>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  </>
);

const UpcomingEvents = (props) => {
  const appName = useContext(AppTypeContext);
  const [loading, setLoading] = useState(true);
  const [events, setEvents] = useState([]);
  const { underlying, postTitle } = props;

  const loadEvents = async () => {
    const response = await API.getUpcomingEvents(underlying);
    // filter long products only - we have to use both names and leverage factor as fallback until leverage factor value are fixed across all products
    if (response.length > 0) {
      const resultEvents = response.map((e) => e);
      setEvents(resultEvents);
    }
    setLoading(false);
  };

  useEffect(() => {
    loadEvents();
  }, []);

  if (loading) {
    return <PlaceholderDiv />;
  }

  if (events.length <= 0) {
    return <div />;
  }

  let date = null;
  return (
    <>
      <Card.Title as="h4">{i18next.t('UpcomingEvents')}</Card.Title>
      <Row className="g-5 py-5 events">
        {events.slice(0, 2).map((event) => {
          const newDate = new Date(event.dt);
          let dtContent = '';
          if (!date || date.getDate() !== newDate.getDate()) {
            dtContent = Utils.formatDate(event.dt);
            date = newDate;
          }
          return (
            <Col xs={12} sm={6} md={6} lg={4} key={`${event.name}-${event.dt}`}>
              <Card className="">
                <Card.Body className="p-4 shadow d-flex flex-column">
                  <Card.Text className="mb-1 fw-bold">{event.name}</Card.Text>
                  <Card.Text className="mb-3 text-muted">{dtContent}</Card.Text>
                  <Button
                    type={
                      postTitle
                        ? `${appName}-${postTitle}-event`
                        : `${appName}-event`
                    }
                    name={event.name}
                    variant="primary"
                    className="text-uppercase fw-bold wt-product-link mt-auto wt-link-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      API.sendToGA(
                        postTitle
                          ? `${appName}-${postTitle}-${event.name}-event`
                          : `${appName}-${event.name}-event`,
                      );
                      heap.track('Heatmap_ClickEventName', {
                        name: event.name,
                      });
                      window.open(process.env.REACT_APP_CALENDAR_URL, '_blank');
                    }}
                  >
                    {i18next.t('ViewEvent')}
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          );
        })}
      </Row>
    </>
  );
};
UpcomingEvents.defaultProps = {
  postTitle: '',
};
UpcomingEvents.propTypes = {
  underlying: PropTypes.string.isRequired,
  postTitle: PropTypes.string,
};

export default UpcomingEvents;
